<template>
	<div>
		<ui-tag-manager-configuration
			v-model="tdm"
			:icon="icon"
			:title="pageTitle"
			:name="getTableName"
			:table-data="table.data"
			:table-columns="table.columns"
			:table-loading="table.loader"
			:orderOptions="orderOptions"
			:filterOptions="filterOptions"
			:last-page="table.lastPage"
			:current-page="table.currentPage"
			:has-select-itens="hasSelectItens"
			:paginate-loader="table.requestLoading"
			placeholder="Separe com vírgula para cadastrar múltiplos itens."
			@next="nextPageHandler"

		/>

		<ui-modal-message
			:name="getModalDeleteName"
			:service="service"
			:title="deleteModalTitle"
			text="Cuidado, esta ação não poderá ser desfeita."
			btn-type="danger"
			btn-text="Confirmar"
			icon="fal fa-trash-alt"
			color-circle="danger"
			icon-circle
		/>

		<ui-edit-tag-modal 
			:name="getModalAddTagName" 
			:service="service" 
			:title="getModalEditTagTitle"

			@success="getData"
		/>
	</div>
</template>

<script>
	import { uiEditTagModal } from '../../modals/tags'
	import uiTagManagerConfiguration from './configuration'
	import { uiModalMessage } from '@/components/ui/modal'
	import { makeOrderOptions, makeFilterOptions } from './data'

	import { alertMixin } from '@/mixins'
	import { pluralize } from '@/filters'

	export default {
		name: 'uiTagManager',
		components: {
			uiTagManagerConfiguration,
			uiModalMessage,
			uiEditTagModal,
		},

		mixins: [alertMixin],
		filters: { pluralize },

		props: {
			service: {
				type: String,
				required: true
			},

			title: {
				type: String,
				required: false,
				default: 'Tags'
			},

			deleteModalTitle: {
				type: String,
				required: false,
				default: 'Deseja realmente excluir a(s) tag(s)?'
			}
		},

		data() {
			return {
				icon: 'fal fa-tags',
				name: 'manager-channels-table-',
				type: 'tags',
				tdm: {},
				api: null,
				table: {
					data: [],
					page: 1,
					per_page: 8,
					lastPage: 1,
					currentPage: 1,
					columns: [
						{ title: 'ID', size: 'control-xs' },
						{ title: 'Label', size: '' },
						{ title: 'Tipo', size: 'control-s' },
						{ title: '', size: 'control-xs' },
					],
					loader: false,
					requestLoading: false,
				},
				orderOptions: [],
				filterOptions: [],
			}
		},

		created() {
			this.$root.$on(this.getCompleteTableName + ':select-all-tags', (bool) => {
				const data = this.table.data.map((item) => {
					item.checked = bool
					return item
				})

				this.table.data = data
			})

			this.$root.$on(this.getCompleteTableName + ':add-tags', (tag) => {
				this.addData(tag)
			})

			this.$root.$on(this.getCompleteTableName + ':edit-tag', (tag) => {
				this.$root.$emit('modal-open-' + this.getModalAddTagName, tag)
			})

			this.$root.$on(this.getCompleteTableName + ':search-tags', () => {
				this.getData()
			})

			this.$root.$on(this.getCompleteTableName + ':select-tag', (tag) => {
				const lineIndex = this.table.data.findIndex((e) => e.id == tag.data.id)

				if(lineIndex == -1) return
				this.table.data[lineIndex].checked = tag.check
			})

			this.$root.$on(this.getCompleteTableName + ':delete-all-selected-tags', () => {
				const list = this.table.data.filter((e) => e.checked).map((e) => e.id).join(',')

				const config = {
					method: 'deleteV2',
					url: '',
					id: list,
					formdata: {},
					eventSuccess: 'modal-msg-' + this.getModalDeleteName + '-response',
				}

				this.$root.$emit('modal-msg-open-' + this.getModalDeleteName, config)
			})

			this.$root.$on(this.getCompleteTableName + ':delete-tag', (tag) => {
				const config = {
					method: 'deleteV2',
					url: '',
					id: tag.id,
					formdata: {},
					eventSuccess: 'modal-msg-' + this.getModalDeleteName + '-response',
				}

				this.$root.$emit('modal-msg-open-' + this.getModalDeleteName, config)
			})

			this.$root.$on(this.getCompleteTableName + ':apply-filter', () => {
				this.getData()
			})

			this.$root.$on('modal-msg-' + this.getModalDeleteName + '-response', () => {
				this.getData()
			})
		},

		beforeDestroy() {
			this.$root.$off(this.getCompleteTableName + ':select-all-tags')
			this.$root.$off(this.getCompleteTableName + ':add-tags')
			this.$root.$off(this.getCompleteTableName + ':edit-tag')
			this.$root.$off(this.getCompleteTableName + ':search-tags')
			this.$root.$off(this.getCompleteTableName + ':select-tag')
			this.$root.$off(this.getCompleteTableName + ':delete-all-selected-tags')
			this.$root.$off(this.getCompleteTableName + ':delete-tag')
			this.$root.$off(this.getCompleteTableName + ':apply-filter')
			this.$root.$off('modal-msg-' + this.getModalDeleteName + '-response')
		},

		async mounted() {
			try {
				if (this.service) {
					const response = await this.loadService()
					this.api = response.default.build()

					await this.getData()
				}

				this.orderOptions = [...makeOrderOptions()]
				this.filterOptions = [...makeFilterOptions()]	
			} catch (e) {
				this.$mx_alertError('Erro ao carregar serviço.')
			}
		},

		computed: {
			pageTitle() {
				return `Gerenciar ${this.titlePlural}`
			},

			titlePlural() {
				return pluralize(this.title)
			},

			canSubmit() {
				return this.$mx_isFormChanged && !this.loader.body
			},

			getTableName() {
				return this.name + this.service
			},

			getCompleteTableName() {
				return 'tag-manager-list-' + this.getTableName
			},

			getModalDeleteName() {
				return this.getTableName + '--modal-delete'
			},

			getModalAddTagName() {
				return this.getTableName + '--new-tag'
			},

			getModalEditTagTitle() {
				return `${this.title}`
			},

			getTagUrl() {
				return '' + this.service
			},

			loadService() {
				return () => import('@/services/axios/modules/' + this.service + '.js')
			},

			hasSelectItens() {
				return this.table.data.filter((e) => e.checked).length > 0
			}
		},

		methods: {
			async getData(loader = 'loader', reset = true) {
				this.table[loader] = true

				if (reset) this.table.page = 1
				
				let opt = this.tdm.filters.data
				const filters = {
					type: opt.filter,
					order: opt.order,
					orderby: opt.orderby,
					search: opt.search,
					per_page: this.table.per_page,
					page: this.table.page
				}

				const response = await this.api.getAllV2('', filters).catch(error => {
					this.$mx_alertThisOnError(error)
					return { data: { data: [] } }
				})

				let data = reset ? [] : [...this.table.data]
				
				const table = [...response.data.data.map(e => {
					return {
						...e,
						type_str: e.type === 'system' ? 'Sistêmica' : 'Usuários',
						checked: false,
						buttons_title: this.title
					}
				})]

				this.table.data = [...data, ...table]

				this.table.currentPage = response.data.page
				this.table.lastPage	= Math.ceil(response.data.total / this.table.per_page)

				this.table[loader] = false
			},

			async addData(tags) {
				const data = {
					slug: tags.tags.split(','),
					type: tags.type || 'system'
				}
				await this.api.createV2('', { ...data }).then((response) => {
					this.$mx_alertSuccess('Adicionado com sucesso!')
				}).catch((e) => {
					this.$mx_alertError(e.data.msg)
				})
				this.getData()
			},

			nextPageHandler() {
				if (this.table.page == this.table.lastPage) return

				this.table.page	= this.table.page + 1
				this.getData('requestLoading', false)
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
